import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { ReclamationActionDetailCodes, ReclamationActionDetailType } from 'constants.js';
import stringHelper from 'utils/stringHelper';

import TextField from '@mui/material/TextField';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';


import DepotGestionSelect from 'components/Shared/DepotGestionSelect';

const styles = theme => ({

    formContent: {
        display: 'flex',
        flexDirection: 'column'
    },

    formControl: {
        width: '100%',
    },

    detailValue: {
        paddingLeft: theme.spacing(4)
    }
});


class DemanderControleStockMagasinContent extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            depotGestionIndex: props.depotGestionIndex,
            codeArticle: '',
            commentaire: "",
            depotGestion: props.depotsGestion[props.depotGestionIndex]
        };
    }


    componentDidMount() {
        this.props.onChange(null);
    }

    getActionData(newState) {
        const { action, depotsGestion } = this.props;
        
        if (stringHelper.isNullOrWhitespace(newState.codeArticle)) {
            return null;
        }

        if (stringHelper.isNullOrWhitespace(newState.commentaire)) {
            return null;
        }


        let depot = depotsGestion[newState.depotGestionIndex];

        let actionData = {
            code: action.code,
            details: [{
                code: ReclamationActionDetailCodes.Depot,
                type: ReclamationActionDetailType.CodeDepot,
                libelle: "Dépôt",
                position: 0,
                valeurString: depot.codeDepot
            },{
                code: ReclamationActionDetailCodes.CodeArticle,
                type: ReclamationActionDetailType.Texte,
                libelle: "Code article",
                position: 1,
                valeurString: newState.codeArticle
            }, {
                code: ReclamationActionDetailCodes.Commentaire,
                type: ReclamationActionDetailType.Texte,
                libelle: "Commentaire",
                position: 2,
                valeurString: newState.commentaire
            }],
            reponseAttendue: true
        };
        
        return actionData;
    }

    handleChange = (event) => {
        const { depotsGestion } = this.props;
        let newState =
        {
            ...this.state,
            [event.target.name]: event.target.value
        };

        if (event.target.name === "depotGestionIndex") {
            let depot = depotsGestion[event.target.value];

            newState = {
                ...newState,
                depotGestion: depot
            };
        }

        this.setState(newState);

        let actionData = this.getActionData(newState);

        this.props.onChange(actionData);
    }

    handleChangeInteger = (event) => {

        let newState;

        newState = {
            ...this.state,
            [event.target.name]: Math.max(event.target.value, 0)
        };

        this.setState(newState);

        let actionData = this.getActionData(newState);

        this.props.onChange(actionData);
    }


    render() {
        const { classes } = this.props;
        const { commentaire, codeArticle, depotGestionIndex, depotGestion } = this.state;
        
        return (
            <DialogContent>
                <div hidden>
                    <Typography variant="body1" gutterBottom>Effectuer cette action pour :</Typography>
                    <Typography variant="body2" gutterBottom className={classes.detailValue}>Demander la destruction des articles à:</Typography>
                    {depotGestion && depotGestion.gestionnaire &&
                        <Typography variant="body2" gutterBottom className={classes.detailValue}>{depotGestion.gestionnaire.nom}</Typography>
                    }
                    {depotGestion && depotGestion.responsable &&
                        <Typography variant="body2" gutterBottom className={classes.detailValue}>{depotGestion.responsable.nom}</Typography>
                    }
                    {(!depotGestion || (!depotGestion.gestionnaire && !depotGestion.responsable)) &&
                        <Typography variant="body2" gutterBottom className={classes.detailValue}>gestionnaire et responsable magasin.</Typography>
                    }
                </div>

                <div className={classes.formContent}>

                    <FormControl margin="normal" className={classes.formControl}>
                        <DepotGestionSelect value={depotGestionIndex} onChange={this.handleChange} all={false} isRequired autoFocus />
                    </FormControl>


                    <TextField className={classes.formControl}
                        required
                        id="codeArticle"
                        name="codeArticle"
                        label="Code article"
                        placeholder="Code article"
                        multiline
                        value={codeArticle}
                        onChange={this.handleChange}
                    />
                                
                    <TextField className={classes.formControl}
                        required
                        id="commentaire"
                        name="commentaire"
                        label="Commentaire"
                        placeholder="Commentaire"
                        multiline
                        value={commentaire}
                        onChange={this.handleChange}
                        />
                </div>
            </DialogContent>
        );
    }
}

DemanderControleStockMagasinContent.propTypes = {
    onChange: PropTypes.func.isRequired,
    action: PropTypes.object.isRequired,
    depotsGestion: PropTypes.array
};

export default withStyles(styles)(DemanderControleStockMagasinContent);